<template>
  <div>
    <div class="swiper-container home_banner">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in BookList"
          :key="index"
        >
          <!-- <img src="../../static/img/首页切片-01.jpg" /> -->
          <div>
            <img :src="item.img" @click="go2(item.name)"/>
            <!-- <div class="top_title_div">
            <p>{{item.name}}</p>
            <hr class="line">
          </div> -->
          </div>
        </div>
        <!-- <div class="swiper-slide">
          <img src="../../static/img/首页切片-02.jpg" />
        </div>
        <div class="swiper-slide">
          <img src="../../static/img/首页切片-03.jpg" />
        </div>
        <div class="swiper-slide">
          <img src="../../static/img/首页切片-04.jpg" />
        </div> -->
      </div>
      <div class="swiper-pagination home_pagination"></div>
      <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      BookList: [],
    };
  },
  created() {},
  computed: {},
  watch: {
    //监听轮播数据变化后再创建实例
    BookList() {
      this.$nextTick(() => {
        this.playMultipleBanner();
      });
    },
  },
  mounted() {
    this.getBookList();
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    getBookList() {
      this.$axios.get("api/homebanner/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.BookList = response.data.page.list;
          }
        }.bind(this)
      );
    },
    playMultipleBanner() {
      var swiper = new Swiper(".home_banner", {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        // pagination: {
        //   el: ".home_pagination",
        //   clickable: true,
        //   renderBullet: function (index, className) {
        //     return '<span class="' + className + '" style="width:24px;height:8px;border-radius:4px ">'+ "</span>";
        //   },
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
    },
      });
    },
    go2(url){
      if(url){
        window.open(url,'_blank');
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.home_pagination {
  bottom: 20%;
}

.top_title_div {
  position: absolute;
  top: 50%;

  p {
    color: white;
    font-size: 5rem;
  }
}

.home_banner {
  //padding: 8rem 0 0;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: white;

  div {
    //width: 100%;
    //margin-left: auto;
    //margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.swiper-button-prev {
  background-image: url('../../static/img/bannerleft.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  //position: absolute;
  width: 5rem;
  height: 5rem;
  margin-left: 10rem;
  outline: none;
}

.swiper-button-prev:hover {
  background-image: url('../../static/img/bannerlefthover.png');
}

.swiper-button-next {
  background-image: url('../../static/img/bannerright.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  //position: absolute;
  width: 5rem;
  height: 5rem;
  margin-right: 10rem;
  outline: none;
}

.swiper-button-next:hover {
  background-image: url('../../static/img/bannerrighthover.png');
}

@media screen and (min-width: 2000px) {
  // .swiper-pagination {
  // margin-top: 50vw;
  // }
}

@media screen and (max-width: 1200px) {
  .home_banner {
    div {
      height: auto;
    }
  }
  .swiper-button-next{
    display: none;
  }
    .swiper-button-prev{
    display: none;
  }
}
</style>